import axios, { AxiosResponse } from 'axios'

const BASE_URL = '/api/invite-code'

export default {
  async verify(code: string): Promise<AxiosResponse> {
    return axios.get(`${BASE_URL}/verify/${code}`)
  },
}
